import * as ActionBar from "@volt_developers/components/components/ActionBar";
import { useEffect } from "react";
import { createPortal } from "react-dom";

import { usePageWrapperRef } from "./PageWrapperWithRefContext";

import type { ReactNode } from "react";

export interface PageActionBarProps {
  children: ReactNode;
  isOpen: boolean;
}

export function PageActionBar({ children, isOpen }: PageActionBarProps) {
  const { ref } = usePageWrapperRef();
  const container = isOpen ? ref.current : null;

  // The sticky bar covers the bottom of the page's scroll area. Without the padding the browser counts a
  // field behind it as visible and does not scroll to it, e.g. when focusing the first invalid one.
  useEffect(() => {
    // The portal appends the bar as the page wrapper's last child.
    const bar = container?.lastElementChild;

    if (!container || !(bar instanceof HTMLElement)) {
      return;
    }

    container.style.scrollPaddingBottom = `${bar.offsetHeight}px`;

    return () => {
      container.style.scrollPaddingBottom = "";
    };
  }, [container]);

  if (!container) {
    return null;
  }

  return createPortal(
    <ActionBar.Wrapper childrenArrangement="space-between" position="bottom">
      {children}
    </ActionBar.Wrapper>,
    container
  );
}
